import Customer from './Customer'
export class RequestCustomer {
    ID?: number;
    RequestID?: number;
    CustomerNumber: string;
    RequestCustomerTypeID: number;
    Customer?: Customer;
}

export default RequestCustomer;